export class AppInfoModel{
    CopyrightYear: string
    SupportEmail: string
    SupportFax: string
    SupportPhone: string
    Version: string
    constructor(){   
        this.CopyrightYear = "",
        this.SupportEmail = "",
        this.SupportFax = "",
        this.SupportPhone = "",
        this.Version = ""
    }
}